import TermsModalModule from "./terms-modal/module";
import acceptTerms from "./directive";

const modul = angular
    .module("AcceptTermsModule", [TermsModalModule])

    .directive("acceptTerms", acceptTerms);

export default modul.name;
